import React from 'react';
import './FleetHealthDonut.css';

const R = 53;
const CIRC = 2 * Math.PI * R;

function FleetHealthDonut({
  onlinePacks = 0, offlinePacks = 0, totalPacks = 0,
  onlineDevices = 0, degradedDevices = 0, offlineDevices = 0,
}) {
  const okLen = totalPacks ? (onlinePacks / totalPacks) * CIRC : 0;
  const downLen = totalPacks ? (offlinePacks / totalPacks) * CIRC : 0;

  return (
    <div className="panel donut-card">
      <div className="fh-overline">Fleet health</div>
      <div className="donut-wrap">
        <div className="donut">
          <svg width="132" height="132" viewBox="0 0 132 132">
            <circle cx="66" cy="66" r={R} stroke="var(--panel-3)" strokeWidth="13" fill="none" />
            <circle cx="66" cy="66" r={R} stroke="var(--down)" strokeWidth="13" fill="none"
              strokeLinecap="round"
              strokeDasharray={`${downLen} ${CIRC - downLen}`}
              strokeDashoffset={-okLen}
              transform="rotate(-90 66 66)" />
            <circle cx="66" cy="66" r={R} stroke="var(--ok)" strokeWidth="13" fill="none"
              strokeLinecap="round"
              strokeDasharray={`${okLen} ${CIRC - okLen}`}
              strokeDashoffset={0}
              transform="rotate(-90 66 66)" />
          </svg>
          <div className="donut-center">
            <div className="donut-big">{onlinePacks}/{totalPacks}</div>
            <div className="donut-lbl">Packs online</div>
          </div>
        </div>
        <div className="fh-legend">
          <div className="fh-row"><span className="fh-sw" style={{ background: 'var(--ok)' }} /><span className="fh-name">Online</span><span className="fh-val">{onlineDevices}</span></div>
          <div className="fh-row"><span className="fh-sw" style={{ background: 'var(--warn)' }} /><span className="fh-name">Degraded</span><span className="fh-val">{degradedDevices}</span></div>
          <div className="fh-row"><span className="fh-sw" style={{ background: 'var(--down)' }} /><span className="fh-name">Offline</span><span className="fh-val">{offlineDevices}</span></div>
          <div className="fh-row fh-total"><span className="fh-name">Total packs</span><span className="fh-val">{totalPacks}</span></div>
        </div>
      </div>
    </div>
  );
}

export default FleetHealthDonut;
